
export interface BarData {
  title: string;
  color: string;
  value: string;
}

const BarChart = ({ data }: { data: BarData[] }) => {
  const allValues = data.map((item) => +item.value);
  const maxValue = Math.ceil(Math.max(...allValues) / 10) * 10;
  return (
    <div className="flex items-stretch justify-center">
      {/* title area */}
      <div>
        {data.map((item, index) => {
          return (
            <div
              key={`TitleItem${index}`}
              className="pr-[11px] text-right text-xs leading-[30px] sm:text-lg sm:leading-[49px]"
            >
              {item.title}
            </div>
          );
        })}
      </div>
      {/* bar area */}
      <div className="flex-1">
        {/* bar chart */}
        <div
          className="relative mr-[4em] border-l-[1px] border-black pb-2.5 before:absolute before:left-[75%] before:top-0 before:h-full before:w-[25%] before:border-l-[1px] before:border-r-[1px] before:border-gray-300 after:absolute after:left-[25%] after:top-0 after:h-full after:w-[25%] after:border-l-[1px] after:border-r-[1px] after:border-gray-300 sm:mr-[5em]"
          aria-label="investment distribution"
        >
          {data.map((item, index) => (
            <div key={index} className="flex items-center gap-x-2">
              <div
                key={`BarItem${index}`}
                style={{
                  width: `${+(+item.value / maxValue).toFixed(3) * 100}%`,
                  backgroundColor: item.color,
                }}
                className="relative my-[6px] h-6 transition-all duration-500 sm:h-9"
              />
              <p
                style={{
                  color: item.color,
                }}
                className="text-sm sm:text-xl"
              >
                {`${item.value}%`}
              </p>
            </div>
          ))}
        </div>
        {/* bar footer */}
        <BarFooter max={maxValue} />
      </div>
    </div>
  );
};

const BarFooter = ({ max }: { max: number }) => {
  const stage = max / 4;
  const stages: number[] = [];
  for (let i = 0; i < 5; i++) {
    stages.push(stage * i);
  }

  return (
    <div className="relative mr-[60px] flex items-center justify-between text-xs after:absolute after:left-full after:top-0 after:pl-4 after:content-['(%)'] sm:mr-[70px] sm:text-lg">
      {stages.map((item, index) => {
        return <div key={`BarFooterItem${index}`}>{item}</div>;
      })}
    </div>
  );
};

export default BarChart;
